import { Component } from "react";
import RouteMenuButton from "./RouteMenuButton";
import { AiOutlineDashboard } from "react-icons/ai";
import { IoSettingsOutline } from "react-icons/io5";
import Cookies from "universal-cookie";

export default class MainMenu extends Component {

    constructor(props) {
        super(props);
        let cookies = new Cookies();
        this.user = cookies.get('user');
    }

    render() {
        return <>
            <RouteMenuButton icon={
                <AiOutlineDashboard size={24} />
            } to="/dashboard" index>Dashboard</RouteMenuButton>
            {this.user.isAdmin && <RouteMenuButton icon={
                <IoSettingsOutline size={24} />
            } to="/ajustes">Ajustes</RouteMenuButton>}
        </>
    }
}